module.exports = '/ng-templates/features/payment/payment-gateway-redirect-response-modal/payment-gateway-redirect-response-modal.tpl.ftl';
